import { normalizeId } from "../utils";

export const budgetKeys = {
  all: ["budget"] as const,

  summary: (projectId: string | number, documentId?: string | number) =>
    documentId
      ? ([...budgetKeys.all, "summary", normalizeId(projectId), normalizeId(documentId)] as const)
      : ([...budgetKeys.all, "summary", normalizeId(projectId)] as const),

  /** Nested under summary so every summary refresh, including after AI runs, refreshes it. */
  fringes: (projectId: string | number, documentId: string | number, budgetId: string) =>
    [...budgetKeys.summary(projectId, documentId), "fringes", budgetId] as const,

  templates: (projectId: string | number, documentId: string | number) =>
    [...budgetKeys.all, "templates", normalizeId(projectId), normalizeId(documentId)] as const,

  versions: (projectId: string | number, documentId: string | number) =>
    [...budgetKeys.all, "versions", normalizeId(projectId), normalizeId(documentId)] as const,

  taxIncentiveRecommendations: (
    projectId?: string | number,
    documentId?: string | number,
    budgetId?: string
  ) =>
    [
      ...budgetKeys.all,
      "tax-incentive-recommendations",
      projectId != null ? normalizeId(projectId) : "unknown-project",
      documentId != null ? normalizeId(documentId) : "unknown-document",
      budgetId ?? "unknown-budget",
    ] as const,

  taxIncentiveCatalog: () => [...budgetKeys.all, "tax-incentive-catalog"] as const,

  budgetBenchmarks: (productionType: string) =>
    [...budgetKeys.all, "budget-benchmarks", productionType] as const,

  budgetBenchmarkMeta: () => [...budgetKeys.all, "budget-benchmarks", "meta"] as const,
};
